<template>
  <div
    v-if="baseGroupCombos && baseGroupCombos.length > 0"
    class="attribute-listing-filters-container"
  >
    <div
      v-for="group in baseGroupCombos"
      :key="group.attributeGroupId"
      class="attribute-listing-filters-group"
    >
      <GroupFilter
        class="attribute-listing-filters-group-wrapper"
        :group="group"
        :entries="group.attributes"
        :is-base-group="true"
      >
      </GroupFilter>
    </div>

  </div>
</template>

<script>
import GroupFilter from './GroupFilter'

export default {
  name: 'BaseGroupListingFilters',
  components: {
    GroupFilter
  },
  props: {
    baseGroupCombos: {
      type: Array
    }
  }
}
</script>
